module.exports = __webpack_public_path__ + "img/minting-soon-bg.0938df3f.png";